(function($) {
    const $slider = $('.slider-logos');

    // Duplicate content to ensure smooth infinite scroll
    $slider.append($slider.html());

    $slider.slick({
        slidesToShow: 15,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 6000,
        cssEase: 'linear',
        infinite: true,
        arrows: false,
        dots: false,
        pauseOnHover: false,
        variableWidth: true
    });
})(jQuery);
